import { useEffect, useState } from "react";
import { useParams } from "react-router";
import { useDispatch, useSelector } from "react-redux";
import styled from "styled-components";
import Modal from "react-responsive-modal";
import sanity, { imageUrlFor } from "src/utils/sanity";
import * as S from "./styled";
import * as Typos from "src/components/atoms/Typographs";
import routes from "src/constants/routes";
import { Link } from "react-router-dom";
import { Btn } from "src/theme/Styled";
import Images from "src/theme/Images";
import CreatePopup from "../WishItems/Popup";
import ShareModal from "../ShareModal";
import ACTIONS from "src/redux/actions";
import { disableBodyOverflow, enableBodyOverflow } from "src/utils/functions";
import giftService from "src/services/gift.service";

import LOGINACTION from "src/redux/actions";
import { LOGIN_NAVIGATE_BUTTON } from "src/theme/Labels";
import { Submit } from "src/components/atoms/Buttons";

const blocksToHyperScript = require("@sanity/block-content-to-hyperscript");

const query = `*[_type == "gift-guides" && _id == $id] {
  _id,
  title,
  mainImage,
  price,
  pricePoint,
  retailer,
  body,
  url
}[0]
`;

const GiftDetail = (props) => {
  const configurations = useSelector(
    (state) => state.users?.configurations || {}
  );
  const isLogged = useSelector((state) => !!state.users?.user?._id);
  const dispatch = useDispatch();
  const [retailers, setRetailers] = useState({});
  const { id } = useParams();
  const [loadStatus, setLoadStatus] = useState(true);
  const [gift, setGift] = useState(null);
  const [description, setDescription] = useState("");
  const [item, setItem] = useState(false);
  const [itemToShare, setItemToShare] = useState(null);
  const [isOpen, setIsOpen] = useState(false);
  const [isShare, setIsShare] = useState(false);
  const [isLoginModal, setisLoginModal] = useState(false);

  const showLoginModal = () => {
    setisLoginModal(true);
  };

  const openSign = () => {
    setisLoginModal(false);
    dispatch({
      type: LOGINACTION.SIDEBAR.OPEN_SIGN,
    });
  };

  const loadItem = (id) => {
    setLoadStatus(true);
    sanity.fetch(query, { id }).then((data) => {
      setGift(data);
      setLoadStatus(false);
      var descHTML = "";
      try {
        descHTML = blocksToHyperScript({
          blocks: data.body,
        });
        const pureDesc = descHTML.innerText || "";
        if (pureDesc.trim()) {
          setDescription(descHTML.innerHTML);
        } else {
          setDescription("");
        }
      } catch (e) {
        setDescription("");
      }
    });
  };

  const openWishItem = (item) => {
    if (!isLogged) {
      dispatch({
        type: ACTIONS.SIDEBAR.OPEN_SIGN,
      });
      return;
    }
    let price_point = "";
    if (item.price) {
      (configurations?.pricePoints || []).some((e) => {
        if (item.price >= e.value1 && item.price <= e.value2) {
          price_point = e.title;
          return true;
        }
      });
    }
    let retailer = "";
    if (item.retailer && item.retailer.length && item.retailer[0]._ref) {
      (configurations?.retailers || []).some((e) => {
        if (e._id === item.retailer[0]._ref) {
          retailer = e.title;
          return true;
        }
      });
    }
    let description = "";
    const wishItem = {
      name: item.title,
      website: item.url,
      retailer,
      price: item.price,
      size: item.size,
      quantity: item.quantity,
      color_flavor: item.color_flavor_type,
      description,
      thumbnail: imageUrlFor(item.mainImage).width(300).url(),
      gift: item._id,
    };
    setItem(wishItem);
    setIsOpen(true);
  };

  const openShareModal = (item) => {
    setItemToShare(item);
    setIsShare(true);
  };

  useEffect(() => {
    loadItem(id);

    const retailerJSON = {};
    (configurations?.retailers || []).forEach((e) => {
      retailerJSON[e._id] = e.title;
    });
    setRetailers(retailerJSON);

    if (!configurations || Object.keys(configurations)) {
      giftService.getConfigurations().then((configurations) => {
        dispatch({
          type: ACTIONS.USER.SET_CONFIG,
          payload: configurations,
        });
        const retailerJSON = {};
        (configurations?.retailers || []).forEach((e) => {
          retailerJSON[e._id] = e.title;
        });
        setRetailers(retailerJSON);
      });
    }
  }, []);

  useEffect(() => {
    if (isOpen || isShare) {
      disableBodyOverflow();
    } else {
      enableBodyOverflow();
    }
  }, [isOpen, isShare]);

  return (
    <>
      <div className="d-flex align-items-center mb-2">
        <Typos.Bread>
          <Link to={routes.GIFTGUIDES}>{"<"} Back to results</Link>
        </Typos.Bread>
        <Btn
          theme="no-border"
          className="ml-auto fit-width d-flex align-items-center"
          onClick={() => openShareModal(gift)}
        >
          <img src={Images.shareIcon} className="d-block" alt="" />
          <Typos.H9 className="ml-1">Share</Typos.H9>
        </Btn>
      </div>
      {loadStatus ? (
        <></>
      ) : (
        <Page>
          <Thumbnail>
            <img
              src={imageUrlFor(gift?.mainImage).ignoreImageParams().width(500)}
              alt="giftguide"
            />
          </Thumbnail>
          <Content>
            <div className="inner">
              <div className="inner-content">
                <Typos.PageTitle className="line-clamp my-3" lines={2}>
                  {gift.title || "unnamed gift"}{" "}
                </Typos.PageTitle>
                <div className="d-flex align-items-center my-2">
                  {gift.price && (
                    <>
                      <Typos.H11>${gift.price}</Typos.H11>
                      {gift.price ? <Spliter></Spliter> : null}
                    </>
                  )}
                  {gift.retailer &&
                    gift.retailer.length &&
                    gift.retailer[0]._ref &&
                    retailers[gift.retailer[0]._ref] ? (
                    <>
                      <Typos.H11 style={{ fontWeight: "600" }}>
                        {retailers[gift.retailer[0]._ref]}
                      </Typos.H11>
                    </>
                  ) : (
                    ""
                  )}
                </div>

                <div className="actions">
                  {gift.url ? (
                    <Btn
                      as="a"
                      href={gift.url}
                      target="_blank"
                      className="d-flex align-items-center justify-content-center"
                    >
                      BUY NOW
                    </Btn>
                  ) : null}
                  {isLogged ? (
                    <Btn
                      theme="outline"
                      className="mt-2"
                      onClick={() => openWishItem(gift)}
                    >
                      ADD TO WISH LIST
                    </Btn>
                  ) : (
                    <Btn
                      theme="outline"
                      className="mt-2"
                      onClick={showLoginModal}
                    >
                      ADD TO WISH LIST
                    </Btn>
                  )}
                </div>

                <div className={description ? "d-block" : "d-none"}>
                  <hr className="mb-2" />
                  <Typos.Desc className="mb-2">Description</Typos.Desc>
                  <Typos.P2
                    as="div"
                    dangerouslySetInnerHTML={{ __html: description }}
                  ></Typos.P2>
                  <hr />
                </div>
              </div>
            </div>
          </Content>

          <Modal
            open={isOpen}
            onClose={() => setIsOpen(false)}
            blockScroll={false}
            classNames={{
              root: "createModalroot",
            }}
          >
            {item.gift ? <CreatePopup item={item} /> : null}
          </Modal>

          <Modal
            open={isShare}
            onClose={() => setIsShare(false)}
            blockScroll={false}
            classNames={{
              root: "shareModalroot",
            }}
          >
            <ShareModal
              data={itemToShare}
              type="gift"
              onClose={() => setIsShare(false)}
              disable={!isLogged}
            />
          </Modal>

          <Modal
            open={isLoginModal}
            blockScroll={false}
            onClose={() => setisLoginModal(false)}
            classNames={{
              root: "loginModalroot",
              modal: "loginModal",
            }}
          >
            <Typos.PageTitle className="login_title">
              Oops, you need to login for that
            </Typos.PageTitle>
            <div className="login_description">
              In order to use that feature, you need to log in or create an
              account.
            </div>
            <div className="login_btn">
              <Submit
                type="button"
                title={LOGIN_NAVIGATE_BUTTON}
                onClick={openSign}
              />
            </div>
          </Modal>
        </Page>
      )}
    </>
  );
};

const Page = styled.div`
  display: grid;
  grid-template-columns: 1fr 1fr;
  grid-gap: 16px;

  @media screen and (max-width: 768px) {
    display: block;
  }
`;

const Thumbnail = styled.div`
  grid-column: 1/2;

  img {
    max-width: 360px;
    max-height: 450px;
    object-fit: contain;
  }

  @media screen and (max-width: 768px) {
    display: flex;
    img {
      margin: auto;
    }
  }
`;

const Content = styled.div`
  grid-column: 2/3;

  .inner {
    max-width: 500px;

    .inner-content {
      max-width: 360px;

      button {
        max-width: 300px;
      }

      .actions {
        margin-top: 30px;
        margin-bottom: 80px;

        a {
          max-width: 300px;
        }
      }

      // @media screen and (max-width: 400px) {
      //   button {
      //     margin: auto;
      //   }
      //   .actions a {
      //     margin: auto;
      //   }
      // }
    }
  }
`;

const Spliter = styled.div`
  width: 1px;
  background-color: black;
  margin-left: 15px;
  margin-right: 15px;
  height: 16px;
`;

export default GiftDetail;
